/* Lucky compact mobile color selector: keeps native Canopy/Shopify inputs and Combined Listings switching intact. */
(function () {
  function init(root) {
    (root || document).querySelectorAll('.product-info .option-selector[data-selector-type="listed"]').forEach(function (fieldset) {
      var group = fieldset.querySelector('.option-selector__btns');
      if (!group) return;
      var labels = Array.from(group.querySelectorAll('label.opt-label--btn'));
      if (labels.length < 20) return;
      fieldset.classList.add('lucky-compact-colors');
      labels.forEach(function (label, index) { label.classList.toggle('lucky-extra-color', index >= 12); });
      var selected = group.querySelector('input:checked');
      if (selected && labels.indexOf(selected.nextElementSibling) >= 12) fieldset.classList.add('lucky-colors-expanded');
      var toggle = fieldset.querySelector('.lucky-color-toggle');
      if (!toggle) {
        toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'lucky-color-toggle';
        group.insertAdjacentElement('afterend', toggle);
        toggle.addEventListener('click', function () {
          fieldset.classList.toggle('lucky-colors-expanded');
          update();
        });
      }
      function update() {
        toggle.textContent = fieldset.classList.contains('lucky-colors-expanded') ? 'Show fewer colors' : 'View all ' + labels.length + ' colors';
        toggle.setAttribute('aria-expanded', fieldset.classList.contains('lucky-colors-expanded') ? 'true' : 'false');
      }
      update();
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('change', function () { setTimeout(function () { init(document); }, 150); });
  if (document.readyState !== 'loading') init(document);
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return; scheduled = true;
    requestAnimationFrame(function () { scheduled = false; init(document); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
